import { render, staticRenderFns } from "./Kf.vue?vue&type=template&id=8cd25aa4&scoped=true"
import script from "./Kf.vue?vue&type=script&lang=js"
export * from "./Kf.vue?vue&type=script&lang=js"
import style0 from "./Kf.vue?vue&type=style&index=0&id=8cd25aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd25aa4",
  null
  
)

export default component.exports